import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// Ionic 7 removed ion-slides; register Swiper Element web components
// (<swiper-container> / <swiper-slide>) globally before bootstrap.
import { register as registerSwiperElements } from 'swiper/element/bundle';
registerSwiperElements();

import { AppModule } from './app/app.module';

import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
